import { Injectable } from '@angular/core';
import { BehaviorSubject, first, Observable } from 'rxjs';

@Injectable()
export class SendDataService {
  private sendData = new BehaviorSubject<any>(undefined);
  private sendDataHeader = new BehaviorSubject<any>(undefined);
  private sendDataCart = new BehaviorSubject<boolean>(false);
  private sendSpinning = new BehaviorSubject<boolean>(false);
  private dataRecruitment = new BehaviorSubject<any>(undefined);
  private isValidSoLuongGioHang = new BehaviorSubject<any>(undefined);
  private sendCheckActiveCategory = new BehaviorSubject<boolean>(false);
  private sendDataCountPost = new BehaviorSubject<number>(0);
  private sendDataLang = new BehaviorSubject<string>('');
  private sendDataCount = new BehaviorSubject<number>(0);
  private myStoreDataSource = new BehaviorSubject<any[]>([]);
  private myStoreOnlineSource = new BehaviorSubject<number>(0);
  myStoreData$ = this.myStoreDataSource.asObservable();
  myStoreOnline$ = this.myStoreOnlineSource.asObservable();

  private updateNumberNotificationSource = new BehaviorSubject<boolean>(false);
  updateNumberNotification$ = this.updateNumberNotificationSource.asObservable();

  constructor() { }


  public sentCheckValidSoLuongGioHang(data: any) {
    this.isValidSoLuongGioHang.next(true);
  }

  public getCheckValidSoLuongGioHang() {
    return this.isValidSoLuongGioHang.asObservable();
  }

  /**
   * Send data recruit ment
   * @param data
   */
  public sendDataRecruitment(data: any) {
    this.dataRecruitment.next(data);
  }

  /**
   * get Data Recruitment
   */
  public getDataRecruitment() {
    return this.dataRecruitment.asObservable();
  }

  /**
   * set Data Send
   * @param data
   */
  public setDataSend(data: any) {
    this.sendData.next(data);
  }

  /**
   * receivedDataSend
   */
  public receivedDataSend(): Observable<any> {
    return this.sendData.asObservable().pipe(first());;
  }

  /**
   * completeSendData
   */
  public completeSendData() {
    this.sendData.complete();
  }

  /**
   *setDataSendCart
   * @param data
   */
  public setDataSendCart(data: boolean) {
    this.sendDataCart.next(data);
  }

  /**
   * receivedDataSendCart
   */
  public receivedDataSendCart(): Observable<boolean> {
    return this.sendDataCart.asObservable();
  }

  /**
   * completeSendDataCart
   */
  public completeSendDataCart() {
    this.sendDataCart.complete();
  }

  /**
   *setDataSendCart
   * @param data
   */
  public setDataSpinning(data: boolean) {
    this.sendSpinning.next(data);
  }

  /**
   * receivedDataSendCart
   */
  public receivedDataSpinning(): Observable<boolean> {
    return this.sendSpinning.asObservable();
  }

  /**
   * completeSendDataSpinning
   */
  public completeSendDataSpinning() {
    this.sendSpinning.complete();
  }

  /**
   * set Data Send
   * @param data
   */
  public setDataSendHeader(data: any) {
    this.sendDataHeader.next(data);
  }

  /**
   * receivedDataSend
   */
  public receivedDataSendHeader(): Observable<any> {
    return this.sendDataHeader.asObservable();
  }

  /**
   * completeSendData
   */
  public completeSendDataHeader() {
    this.sendDataHeader.complete();
  }

  /**
  *setDataSendCart
  * @param data
  */
  public setDataSendActiveCategory(data: boolean) {
    this.sendCheckActiveCategory.next(data);
  }

  /**
   * receivedDataSendCart
   */
  public receivedDataSendActiveCategory(): Observable<boolean> {
    return this.sendCheckActiveCategory.asObservable();
  }

  /**
   * completeSendDataCart
   */
  public completeSendActiveCategory() {
    this.sendCheckActiveCategory.complete();
  }

  /**
   * set Data Send
   * @param data
   */
  public setDataSendCountPost(data: number) {
    this.sendDataCountPost.next(data);
  }

  /**
   * receivedDataSend
   */
  public receivedDataSendCountPost(): Observable<number> {
    return this.sendDataCountPost.asObservable();
  }

  /**
   * completeSendData
   */
  public completeSendDataCountPost() {
    this.sendDataCountPost.complete();
  }

  /**
  * set Data Send
  * @param data
  */
  public setDataSendLang(data: string) {
    this.sendDataLang.next(data);
  }

  /**
   * receivedDataSend
   */
  public receivedDataSendLang(): Observable<string> {
    return this.sendDataLang.asObservable();
  }

  /**
   * set Data Send
   * @param data
   */
  public setDataSendCountUnresponsive(data: number) {
    this.sendDataCount.next(data);
  }

  /**
   * setStaffStoreDatas
   * @param data 
   */
  setStaffStoreDatas(data: any[]) {
    this.myStoreDataSource.next(data);
  }

  /**
   * setMyStoreOnline
   * @param count 
   */
  setMyStoreOnline(count: number) {
    this.myStoreOnlineSource.next(count);
  }

  /**
   * setUpdateNumberNotification
   * @param boolean 
   */
  setUpdateNumberNotification(boolean: boolean) {
    this.updateNumberNotificationSource.next(boolean);
  }
}
